export default __webpack_public_path__ + "static/media/right_bg.a2665278.png";